import React from "react";

const STATUS = {
  in_stock: { cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500", label: "In Stock" },
  low_stock: { cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500", label: "Low Stock" },
  out_of_stock: { cls: "bg-rose-50 text-rose-800 border-rose-200", dot: "bg-rose-500", label: "Out of Stock" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || STATUS.in_stock;
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot} ${status === "out_of_stock" ? "animate-pulse" : ""}`} />
      {s.label}
    </span>
  );
};

const CAT = {
  finished: "bg-amber-100/70 text-amber-900 border-amber-300/60",
  raw: "bg-emerald-100/70 text-emerald-900 border-emerald-300/60",
  packaging: "bg-blue-100/70 text-blue-900 border-blue-300/60",
  merchandise: "bg-fuchsia-100/70 text-fuchsia-900 border-fuchsia-300/60",
};
const CAT_LABEL = { finished: "Finished", raw: "Raw", packaging: "Packaging", merchandise: "Merch" };

export const CategoryBadge = ({ category }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${CAT[category] || CAT.raw}`}>
    {CAT_LABEL[category] || category}
  </span>
);

const RUN = {
  complete: "bg-violet-50 text-violet-800 border-violet-200",
  in_progress: "bg-blue-50 text-blue-800 border-blue-200",
  scheduled: "bg-stone-100 text-stone-700 border-stone-200",
  draft: "bg-stone-100 text-stone-600 border-stone-200",
  active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  passed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  hold: "bg-amber-50 text-amber-800 border-amber-200",
};

export const RunBadge = ({ status }) => (
  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border capitalize ${RUN[status] || RUN.scheduled}`}>
    {String(status).replace("_", " ")}
  </span>
);

export const SkuTag = ({ code }) => (
  <span className="font-mono text-xs font-medium text-stone-800 bg-stone-100 px-1.5 py-0.5 rounded border border-stone-200">{code}</span>
);
